import React, { useEffect, useContext } from 'react';
import useMergeState from 'utils/hooks/useMergeState';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import LinkList from 'components_v2/common/LinkList';
import CityModal from '../CityModal/CityModalLoader';
import Listingheader from '../../common/ListingheaderV2';
import s from './ThreeColLayout.scss';
import { cityNameMap } from '../../../../../utils/common';

const SmallList = props => {
  const {
    dataObj,
    index,
    geoCityData = { city: '' },
    ga4Type,
    ga4Category,
  } = props;
  let listItems;
  const globalState = useContext(UserPreferenceContext);
  const [state, updateState] = useMergeState({
    shouldshowModal: false,
    loading: false,
    ajaxCall: false,
    itemsState: null,
    cityForSection: null,
    navItems: null,
  });

  if (state.ajaxCall) {
    listItems = state.itemsState;
  } else {
    listItems = dataObj.data || dataObj.items || state.itemsState || [];
  }

  const loadSectionData = (dataUrl, isAjaxCall) => {
    if (!dataUrl) {
      return;
    }

    updateState({ loading: true });

    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data?.data?.items?.length > 0) {
        updateState({ itemsState: data.data.items });
      }
      updateState({ ajaxCall: !!isAjaxCall });
      updateState({ loading: false });
    });
  };

  const loadDataForCity = city => {
    if (typeof city !== 'string') {
      return;
    }
    const cityName = city.toLocaleLowerCase();
    const { navItems } = state;

    if (!Array.isArray(navItems)) {
      return;
    }
    const filteredCityByAlphabet = navItems.filter(node => {
      const alphabet =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      return alphabet === cityName[0];
    });
    if (
      !(
        Array.isArray(filteredCityByAlphabet) &&
        Array.isArray(filteredCityByAlphabet[0]?.items)
      )
    ) {
      return;
    }
    const filteredCity = filteredCityByAlphabet[0].items.filter(node => {
      const nodeName =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      return nodeName === cityName;
    });
    loadSectionData(filteredCity[0] && filteredCity[0].dataUrl, true);
  };

  const toggleModal = () => {
    updateState({ shouldshowModal: !state.shouldshowModal });
  };

  const fetchNavigation = dataUrl => {
    if (!dataUrl) {
      return;
    }
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (!data?.data?.items) {
        return;
      }
      updateState({
        navItems: data.data.items,
      });
    });
  };

  const loadNavigationData = () => {
    if (dataObj.subSections && dataObj.subSections.dataUrl) {
      fetchNavigation(dataObj.subSections.dataUrl);
    }
  };

  // useEffect(() => {
  //   fetchNavigation(dataObj?.subSections?.dataUrl);
  // }, []);

  useEffect(
    () => {
      loadDataForCity(props?.geoCityData?.city);
      return () => {
        //~unmount
      };
    },
    [props?.geoCityData?.city, state.navItems],
  );

  const onTabsChange = params => {
    let cityForSection = null;
    const { clickedItem } = params;
    if (clickedItem?.dataUrl) {
      loadSectionData(clickedItem.dataUrl, true);
    }
    if (
      clickedItem?.name &&
      params?.confirmMakingDefCity &&
      typeof globalState?.setLanguageVal === 'function'
    ) {
      globalState.setLanguageVal(clickedItem.name, true);
    } else {
      cityForSection = clickedItem.name;
    }
    updateState({
      cityForSection,
    });
  };

  if (listItems instanceof Array) {
    return (
      <InViewObserver
        inViewCallback={() => {
          loadNavigationData();
        }}
        viewMargin="300px 0px 300px 0px"
        className={`${'col_l_4 col_m_4'} ${s.ent_listing}`}
        key={`ls-${index}`}
      >
        {state.loading && <LoaderSpinner />}
        <Listingheader
          headingLink={dataObj.link || dataObj.path}
          headingname={dataObj.name}
          size="small"
          newga={`${dataObj.name}Section_Actions#HeadingClick`}
          ga4Type={ga4Type}
          ga4Category={ga4Category}
        >
          <>
            {state.shouldshowModal && dataObj.subSections?.dataUrl ? (
              <CityModal
                dataUrl={dataObj.subSections.dataUrl}
                onChangeCallback={onTabsChange}
                // newga={`${dataObj.name}Section_Actions_CityChange#CityChange_`}
                gaData={{
                  gaAction: `${dataObj.name}Section_CityChange`,
                  partialGaLabel: 'CityChange_',
                }}
                geoCityData={geoCityData}
                toggleModal={toggleModal}
              />
            ) : null}
            {dataObj.subSections && dataObj.subSections.dataUrl ? (
              <div className={s.cityDropdown}>
                <div className={s.currentcity}>
                  {cityNameMap[state.cityForSection] ||
                    state.cityForSection ||
                    cityNameMap[geoCityData?.city] ||
                    geoCityData?.city ||
                    ''}
                </div>
                <div className={s.changecity} onClick={toggleModal}>
                  Change City
                </div>
              </div>
            ) : null}
          </>
        </Listingheader>
        <LinkList
          data={listItems}
          showIcon
          className="linktype1"
          newga={`${dataObj.name}Section_Actions#$typeClick-$index`}
          ga4Type={ga4Type}
          ga4Category={ga4Category}
        />
      </InViewObserver>
    );
  }
  return null;
};

export default SmallList;
